<template>
  <section class="feed-container">
    <section class="svg-background">
      <!--<a href="https://www.osfatun.com.ar/"><h2 class="title title-web"><span>Ir al sitio web</span></h2></a>-->
    </section>

    <ul class="icons soloMobile">
      <li><a target="_blank" href="https://www.facebook.com/osfatunoficial"> <img src="./../../assets/icon-facebook.svg" alt="" /> </a></li>
      <li><a target="_blank" href="https://www.instagram.com/osfatunoficial"> <img src="./../../assets/icon-instagram.svg" alt="" /> </a></li>
    </ul>
    <ul class="icons soloMobile mt-5">
      <li><h2 class="title">Seguinos</h2></li>
      <li class="second"><img src="./../../assets/en-las-redes.svg" alt="" /></li>
    </ul>

    <ul class="icons soloDesktop">
      <li><h2 class="title">Seguinos</h2></li>
      <li class="second"><img src="./../../assets/en-las-redes.svg" alt="" /></li>
      <li><a target="_blank" href="https://www.facebook.com/osfatunoficial"> <img src="./../../assets/icon-facebook.svg" alt="" /> </a></li>
      <li><a target="_blank" href="https://www.instagram.com/osfatunoficial"> <img src="./../../assets/icon-instagram.svg" alt="" /> </a></li>
    </ul>

    <section class="instagramfeed-container">
      <InstagramFeed />
    </section>

  </section>
</template>

<script>
import InstagramFeed from './../InstagramFeed'
export default {
  name: "LandingBody",
  components:{
    InstagramFeed,
  }
};
</script>

<style scoped>
h2.title {
  color: #00758f;
  text-align: center;
}
.title-web{
  padding: 7% 0;
  text-transform: uppercase;
}
.title-web span {
  border-bottom: 5px solid sandybrown;
}
ul.icons {
  justify-content: center;
}
ul.icons li {
  border: 0;
  vertical-align: text-bottom;
}
ul.icons li h2.title{ margin: 0; padding: 0;}
ul.icons li.second {
  padding-bottom: 15px;
}
.svg-background{
  width: 100%;
  background: url("./../../assets/title-background.svg") center center no-repeat;
  background-size: 100%;
}
.instagramfeed-container{
  margin-top: 10px;
  padding: 10px;
}
.soloMobile{ display: none; }
@media screen and (max-width: 42em) {
  .title-web{ display: none; }
  .soloDesktop{ display: none; }
  .soloMobile{ display: grid; grid-gap: 10px;}
  .svg-background{ margin-bottom: 40px;}
  .instagramfeed-container{
    overflow: hidden;
    margin-top: 30px;
  }
}

</style>
